export default __webpack_public_path__ + "25182393cca510c5e6649bb04874afd5.png";